import initSlider from 'javascripts/globals/slider';

document.querySelectorAll('.js-swiper').forEach(($swiperOuter) => {
  initSlider($swiperOuter);
});
